var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-sidebar"},_vm._l((_vm.data),function(item,key){return _c('xc-menu-item',{key:key,attrs:{"data":item,"labelKey":_vm.labelKey,"idKey":_vm.idKey,"urlPrefix":_vm.urlPrefix,"select":_vm.select,"topId":item[_vm.idKey]},on:{"open":_vm.open,"close":_vm.close}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }